import { render, staticRenderFns } from "./LastViewed.vue?vue&type=template&id=7fd97db8"
import script from "./LastViewed.vue?vue&type=script&lang=js"
export * from "./LastViewed.vue?vue&type=script&lang=js"
import style0 from "./LastViewed.vue?vue&type=style&index=0&id=7fd97db8&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports